import { http } from '@/http'

/**
 * Mantenimientos de vehículo de flota (DEF-ADM-015 Fase 3).
 * El header X-City-Id lo agrega el interceptor global.
 */
export default {
  // Dashboard por vehículo: km actual, próximo servicio, restantes, fecha estimada, estado.
  status() {
    return http.get('/api/v1/fleet/maintenances/status')
  },
  // Proyección detallada de un vehículo.
  projection(vehicleId) {
    return http.get(`/api/v1/fleet/maintenances/projections/${vehicleId}`)
  },
  // Historial de mantenimientos.
  list(params) {
    return http.get('/api/v1/fleet/maintenances', { params })
  },
  get(id) {
    return http.get(`/api/v1/fleet/maintenances/${id}`)
  },
  create(data) {
    return http.post('/api/v1/fleet/maintenances', data)
  },
  update(id, data) {
    return http.put(`/api/v1/fleet/maintenances/${id}`, data)
  },
  remove(id) {
    return http.delete(`/api/v1/fleet/maintenances/${id}`)
  },
  uploadPhoto(id, file) {
    const fd = new FormData()
    fd.append('photo', file)
    return http.post(`/api/v1/fleet/maintenances/${id}/photo`, fd)
  },
  getPhoto(id) {
    return http.get(`/api/v1/fleet/maintenances/${id}/photo`)
  },
  // Configuración (intervalo km + taller) por vehículo.
  getConfig(vehicleId) {
    return http.get(`/api/v1/fleet/maintenances/config/${vehicleId}`)
  },
  saveConfig(vehicleId, data) {
    return http.put(`/api/v1/fleet/maintenances/config/${vehicleId}`, data)
  }
}
